import React from 'react';

import { Flex, FormLabel, Switch } from '@tapresearch/ui/components';

interface HideEmptySwitchProps {
  isHiding: boolean;
  isSwitching: boolean;
  setIsHiding: (value: boolean) => void;
}
export const HideEmptySwitch = ({
  isHiding,
  isSwitching,
  setIsHiding,
}: HideEmptySwitchProps) => {
  return (
    <Flex
      data-testid="hide-empty-switch-container"
      align="center"
      lineHeight="8"
      justify="flex-end"
      mt={4}
    >
      <FormLabel m={0} fontWeight="normal" fontSize="sm" lineHeight="normal">
        Hide empty results:
      </FormLabel>
      <Flex w="45px" justify="flex-end">
        <Switch
          data-testid="hide-empty-switch"
          isChecked={isHiding}
          isDisabled={isSwitching}
          onChange={() => setIsHiding(!isHiding)}
          ml={2}
        />
      </Flex>
    </Flex>
  );
};
